(() => {
  if (window.__ndwLeadTrackingLoaded || window.Shopify?.designMode) return;
  window.__ndwLeadTrackingLoaded = true;

  const measurementId = 'G-10VP3R1JBC';
  const pendingKey = 'ndw_contact_lead_pending';
  const sentKey = 'ndw_contact_lead_sent';
  const queue = new Map();

  const readStored = (key) => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch {
      return null;
    }
  };

  const writeStored = (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {}
  };

  const removeStored = (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {}
  };

  const newAttempt = () => ({
    id: window.crypto?.randomUUID?.() || String(Date.now()) + '-' + Math.random().toString(36).slice(2),
    path: window.location.pathname,
    createdAt: Date.now()
  });

  const flush = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    if (!privacy.analyticsProcessingAllowed() || typeof window.gtag !== 'function') return;

    for (const [id, lead] of queue) {
      try {
        window.gtag('event', lead.name, {
          send_to: measurementId,
          form_id: lead.formId,
          lead_type: lead.type,
          method: lead.method,
          page_location: window.location.origin + window.location.pathname
        });
        queue.delete(id);
        if (lead.type === 'contact') {
          writeStored(sentKey, { id });
          removeStored(pendingKey);
        }
      } catch {}
    }
  };

  const enqueue = (attempt, name, formId, type, method) => {
    queue.set(attempt.id, { name, formId, type, method });
    flush();
  };

  if (typeof window.Shopify?.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => flush());
  }

  document.addEventListener('visitorConsentCollected', flush);
  let flushAttempts = 0;
  const flushTimer = window.setInterval(() => {
    flush();
    if (++flushAttempts >= 60) window.clearInterval(flushTimer);
  }, 500);

  const contact = document.getElementById('ContactForm');
  if (contact) {
    contact.addEventListener('submit', () => {
      writeStored(pendingKey, newAttempt());
    });

    const attempt = readStored(pendingKey);
    const sent = readStored(sentKey);
    const recent = attempt && attempt.path === window.location.pathname &&
      Date.now() - attempt.createdAt >= 0 && Date.now() - attempt.createdAt < 30 * 60 * 1000;

    if (recent && sent?.id !== attempt.id && contact.querySelector('[data-ndw-lead-success="contact"]')) {
      enqueue(attempt, 'contact_submit', 'ContactForm', 'contact', 'shopify_contact');
    } else if (attempt && !recent) {
      removeStored(pendingKey);
    }
  }

  if (window.location.pathname.replace(/\/$/, '') !== '/pages/trade-custom-form') return;

  let bindAttempts = 0;
  const bindCustomForm = () => {
    const host = document.querySelector('[data-forms-id="forms-root-847255"] shopify-forms-embed');
    const root = host?.shadowRoot;
    const state = root?.getElementById('app-embed');
    if (!root || !state) return false;
    let attempt = null;

    root.addEventListener('submit', (event) => {
      if (event.target.matches('form[data-testid="form"]')) attempt = newAttempt();
    }, true);

    const observer = new MutationObserver(() => {
      if (!attempt || state.getAttribute('data-current-step') !== 'success') return;
      const completed = attempt;
      attempt = null;
      enqueue(completed, 'custom_request_submit', '847255', 'custom_trade', 'shopify_forms');
    });
    observer.observe(state, { attributes: true, attributeFilter: ['data-current-step'] });
    return true;
  };

  if (!bindCustomForm()) {
    const bindTimer = window.setInterval(() => {
      if (bindCustomForm() || ++bindAttempts >= 120) window.clearInterval(bindTimer);
    }, 500);
  }
})();

